<template>
  <div>
    <Title :title="'电池告警及故障率'"></Title>
    <Chart :cdata="cdata" :height="style.height" :width="style.width"/>
  </div>
</template>

<script>
import BigTitle from '../../bigTitle';
import Chart from '../chart.vue'
import Title from '../../title.vue'
import { dataInterface } from '@/api/dataInterfaceApi';

export default {
  data () {
    return {
      style:{
        width: '550',
        height: '250'
      },
      cdata: {
        category: [
          "1月",
          "2月",
          "3月",
          "4月",
          "5月",
          "6月",
          "7月",
          "8月",
          "9月",
          "10月",
          "11月",
          "12月",
        ],
        rateData: [],
        id:"carAddChart",
        legendData:[{
              name:"电池告警",
              icon: 'roundRect',
        },{
              name:"故障率",
              icon: 'roundRect',
        }],
        series:[
            {
              name: "电池告警",
              type: "line",
              barWidth: 10,
              itemStyle: {
                normal: {
                  color: '#D3A43E'
                }
              },
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            },
            {
              name: "故障率",
              type: "line",
              barWidth: 10,
              itemStyle: {
                normal: {
                  color: '#7560BE'
                }
              },
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            },
        ],
        yAxisname:""
      }
    };
  },
  components: {
    BigTitle,
    Chart,
    Title
  },
  mounted () {
  },
  methods: {
    getData(data){
      this.selectBatteryAlarmInfo(data)
    },
    selectBatteryAlarmInfo(data={}){
      let _this = this;
      let params = {
				"enCode":"TiDB-congdiancang-dianchigaojingjiguzhanglv",
        "@station_id":data.stationId,
        "@battery_id":data.batteryId
			}
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if(!res) return;
          let alarm_count_num = [];
          let error_rate = [];
          let xList = [];
          res.forEach(item=>{
            alarm_count_num.push(item.alarm_count_num);
            error_rate.push(item.error_rate);
            xList.push(item.cur_date);
          })
          this.cdata.series[0].data = alarm_count_num;//告警次数
          this.cdata.series[1].data = error_rate;//故障率
          this.cdata.category = xList;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    
    
  }
};
</script>

<style lang="scss" scoped>
</style>